const extractNumber = value => Number(String(value).replace(/[\D]/g, ''));

export default extractNumber;
